<template>
    <div id="down">
        <!--<canvas :id="id" width="50" height="50">你的浏览器不支持canvas，请下载更新版本的浏览器-->
        <!--</canvas>-->
        <img src="../../../static/wap_images/arrow.svg" alt="">
    </div>
</template>

<script>
    export default {
        name: "arrow",
        props:[
            'id'
        ],
        mounted(){
            let that=this;
            function drawDown() {
                var c = document.getElementById(that.id),
                    cxt = c.getContext("2d");
                cxt.beginPath();
                cxt.moveTo(5, 20);
                cxt.lineTo(25, 45);
                cxt.lineTo(45, 20);
                cxt.lineWidth = 3;
                cxt.strokeStyle = "#ccc";
                cxt.lineCap = 'round';
                cxt.lineJoin = "round";
                cxt.stroke();
                cxt.beginPath();
                cxt.moveTo(5, 5);
                cxt.lineTo(25, 30);
                cxt.lineTo(45, 5);
                cxt.lineWidth = 3;
                cxt.strokeStyle = "#a6a6a6";
                cxt.lineCap = 'round';
                cxt.lineJoin = "round";
                cxt.stroke();
            }
            drawDown()
        }
    }
</script>

<style scoped lang="scss">
    @-moz-keyframes myMove {
        0% {padding-top:30px;}
        100% {padding-top:50px;}
    }
    @-webkit-keyframes myMove {
        0% {padding-top:30px;}
        100% {padding-top:50px;}
    }
    @-o-keyframes myMove {
        0% {padding-top:30px;}
        100% {padding-top:50px;}
    }
    @keyframes myMove {
        0% {padding-top:30px;}
        100% {padding-top:50px;}
    }
    #down {
        text-align: center;
        height: 1.2rem;
        -moz-animation: myMove 1s linear infinite alternate;
        -webkit-animation: myMove 1s linear infinite alternate;
        -o-animation: myMove 1s linear infinite alternate;
        animation: myMove 1s linear infinite alternate;


        /*transform: rotate(180deg);*/
        img{
            width: .34rem;
            height: .34rem;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/common/arrow.vue